// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__eG2PB","emails":"CreateEditClinics_emails__2dLtW","emailTagLabel":"CreateEditClinics_emailTagLabel__3-XiE"};